<template>
  <div>
    <form-wizard
      ref="formWizard"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      class="wizard-vertical mb-3"
    >
      <!-- Tab: Profil -->
      <tab-content
        title="Profil"
      >
        <BrandFormProfile
          ref="BrandFormProfile"
          :form="form"
          :is-edit="isEdit"
          :is-profile="isProfile"
        />
      </tab-content>

      <!-- Tab: Alamat -->
      <tab-content
        title="Alamat"
      >
        <BrandFormAddress
          ref="BrandFormAddress"
          :form="form"
        />
      </tab-content>

      <!-- Tab: Kurir -->
      <tab-content title="Kurir">
        <BrandFormCourier
          v-if="!isPending"
          :form="form"
          :is-edit="isEdit"
          :is-profile="isProfile"
        />
      </tab-content>

      <!-- Tab: Pickup -->
      <tab-content
        title="Pickup"
      >
        <BrandFormPickup
          ref="BrandFormPickup"
          :form="form"
        />
      </tab-content>

      <template
        slot="footer"
        slot-scope="props"
      >
        <div class="wizard-footer-left">
          <wizard-button
            v-if="props.activeTabIndex > 0"
            :style="props.fillButtonStyle"
            @click.native="props.prevTab()"
          >
            Kembali
          </wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button
            v-if="props.activeTabIndex === 0"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            :disabled="isSubmitting"
            @click.native="validateBrandProfile"
          >
            <b-spinner
              v-if="isSubmitting"
              small
            />
            Simpan dan Lanjutkan
          </wizard-button>
          <wizard-button
            v-else-if="props.activeTabIndex === 1"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            :disabled="isSubmitting"
            @click.native="validateBrandAddress"
          >
            <b-spinner
              v-if="isSubmitting"
              small
            />
            Simpan dan Lanjutkan
          </wizard-button>
          <wizard-button
            v-else-if="props.activeTabIndex === 2"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            @click.native="validateBrandCourier"
          >
            Simpan dan Lanjutkan
          </wizard-button>
          <wizard-button
            v-else-if="props.activeTabIndex === 3"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            :disabled="isSubmitting"
            @click.native="validateBrandPickup"
          >
            <b-spinner
              v-if="isSubmitting"
              small
            />
            Simpan dan Selesai
          </wizard-button>
          <!-- <wizard-button
            v-if="!props.isLastStep"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            :disabled="isSubmitting"
            @click.native="props.nextTab()"
          >
            <b-spinner
              v-if="isSubmitting"
              small
            />
            Simpan dan Lanjutkan
          </wizard-button> -->
        </div>
      </template>

      <template
        slot="step"
        slot-scope="props"
        :tab="props.tab"
        :transition="props.transition"
        :index="props.index"
      />
    </form-wizard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import {
// BButton,
  BSpinner,
} from 'bootstrap-vue'

import BrandFormAddress from '@/layouts/components/form/BrandFormAddress.vue'
import BrandFormPickup from '@/layouts/components/form/BrandFormPickup.vue'
import BrandFormProfile from '@/layouts/components/form/BrandFormProfile.vue'
import BrandFormCourier from '@/layouts/components/form/BrandFormCourier.vue'

// form wizard
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Ripple from 'vue-ripple-directive'

export default {
  components: {
    // BButton,
    BSpinner,

    // form
    BrandFormAddress,
    BrandFormPickup,
    BrandFormProfile,
    BrandFormCourier,

    // vue form wizard
    FormWizard,
    TabContent,
    WizardButton,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        image: '',
        imageFile: '',
        name: '',
        email: '',
        password: '',
        order: '',
        phone: '',
        description: '',
        is_active: null,
        is_open: null,
        is_gift_wrap_enabled: null,
        shopee_id: '',
        postal_code: '',
        address: null,
        district: {},
        pickup_jne_branch: '',
        pickup_latitude: '',
        pickup_longitude: '',
        pickup_pic_name: '',
        pickup_pic_phone: '',
        pickup_vehicle: '',
        pickup_time: '',
        is_pickup_jne_enabled: true,
      },
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('brand', ['brand', 'selectedCouriers']),

    brandId() {
      if (this.isEdit) {
        return this.$route.params.id
      }

      if (this.isProfile) {
        return this.$store.state.auth.userData.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getBrand({ id: this.brandId })
      this.fillData()
      if (this.brand.address) {
        this.$refs.formWizard.activateAll()
      } else if (this.brand.id) {
        this.$refs.formWizard.nextTab()
      }
    }

    if (this.isProfile) {
      await this.getBrandProfileMe()
      this.fillData()
      if (this.brand.address) {
        this.$refs.formWizard.activateAll()
      } else if (this.brand.id) {
        this.$refs.formWizard.nextTab()
      }
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('brand', [
      'createBrandProfile',
      'getBrand',
      'getBrandProfileMe',
      'updateBrandProfile',
      'updateBrandAddress',
      'updateBrandProfileMe',
      'updateBrandAddressMe',
      'updateBrandPickup',
      'updateBrandPickupMe',
    ]),
    // submit section
    async handleSubmitProfile() {
      this.isSubmitting = true

      if (this.isEdit) {
        await this.updateBrandProfile({ data: this.form, brandId: this.brandId }).then(() => {
          this.$refs.formWizard.nextTab()
        })
      } else if (this.isProfile) {
        await this.updateBrandProfileMe({ data: this.form }).then(async () => {
          this.$refs.formWizard.nextTab()

          const user = await this.loadUser()
          const ability = user.permissions

          const userData = {
            ...user,
            role: user.roles,
            ability,
          }

          await this.$ability.update(ability)
          await this.$store.commit('auth/UPDATE_USER_DATA', userData)
          this.$nextTick(this.$forceUpdate)
        })
      } else {
        const profile = await this.createBrandProfile(this.form)
        const idBrand = profile.data.id
        this.$router.push(`/brands/${idBrand}/edit`)
      }

      this.isSubmitting = false
    },
    async handleSubmitAddress() {
      this.isSubmitting = true

      this.form.state_id = this.form.district.province_id
      this.form.city_id = this.form.district.city_id
      this.form.district_id = this.form.district.district_id

      if (this.isProfile) {
        this.updateBrandAddressMe({ data: this.form })
      } else {
        this.updateBrandAddress({ data: this.form, brandId: this.brandId })
      }

      this.isSubmitting = false
    },
    async handleSubmitPickup() {
      const data = {
        pickup_jne_branch: this.form.pickup_jne_branch,
        pickup_latitude: this.form.pickup_latitude,
        pickup_longitude: this.form.pickup_longitude,
        pickup_pic_name: this.form.pickup_pic_name,
        pickup_pic_phone: this.form.pickup_pic_phone,
        pickup_vehicle: this.form.pickup_vehicle,
        pickup_time: this.form.pickup_time,
        is_pickup_jne_enabled: true,
      }

      this.isSubmitting = true

      if (this.isProfile) {
        await this.updateBrandPickupMe({ data })
      } else {
        await this.updateBrandPickup({ data, brandId: this.brandId })
      }

      this.isSubmitting = false
    },
    // validate section
    validateBrandProfile() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.BrandFormProfile.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.handleSubmitProfile()
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
            }
            this.isSubmitting = false
          })
        }, 1000)
      })
    },
    validateBrandAddress() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.BrandFormAddress.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.handleSubmitAddress()
              this.$refs.formWizard.nextTab()
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
            }
            this.isSubmitting = false
          })
        }, 1000)
      })
    },
    validateBrandPickup() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.BrandFormPickup.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.handleSubmitPickup().then(() => {
                this.$router.push('/brands')
              })
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
            }
            this.isSubmitting = false
          })
        }, 1000)
      })
    },
    validateBrandCourier() {
      if (this.selectedCouriers.length > 0) {
        this.$refs.formWizard.nextTab()
      } else {
        this.$store.commit('response/SET_ERROR', {
          message: 'Harap aktifkan minimal 1 kurir!',
        })
      }
    },
    // Edit State Only
    fillData() {
      this.form = this.brand
      this.form.is_active = this.brand.is_active ? 1 : 0
      this.form.is_open = this.brand.is_open ? 1 : 0
      this.form.is_gift_wrap_enabled = this.brand.is_gift_wrap_enabled ? 1 : 0
      this.form.image = this.form.image_url
      if (this.brand.address) {
        this.form.district = {
          city_id: this.brand.address.city_id,
          city_name: this.brand.address.city_name,
          district_id: this.brand.address.district_id,
          district_name: this.brand.address.district_name,
          province_id: this.brand.address.province_id,
          province_name: this.brand.address.province_name,
        }
        this.form.postal_code = this.brand.address.postal_code
        this.form.is_pickup_jne_enabled = this.brand.address.is_pickup_jne_enabled
        this.form.pickup_jne_branch = this.brand.address.pickup_jne_branch
        this.form.pickup_latitude = this.brand.address.pickup_latitude
        this.form.pickup_longitude = this.brand.address.pickup_longitude
        this.form.pickup_pic_name = this.brand.address.pickup_pic_name
        this.form.pickup_pic_phone = this.brand.address.pickup_pic_phone
        this.form.pickup_time = this.brand.address.pickup_time
        if (this.brand.address.pickup_vehicle) {
          this.form.pickup_vehicle = this.brand.address.pickup_vehicle
        } else {
          this.form.pickup_vehicle = ''
        }
        this.form.address = this.brand.address.address
      } else {
        this.form.district = null
        this.form.postal_code = null
        this.form.address = null
      }
    },
    // Profile State Only
    fillDataProfile() {
      const userData = this.$store.state.auth.userData.merchant
      this.form = userData
      this.form.is_active = userData.is_active ? 1 : 0
      this.form.is_open = userData.is_open ? 1 : 0
      this.form.is_gift_wrap_enabled = userData.is_gift_wrap_enabled ? 1 : 0
      this.form.image = this.form.image_url
    },
    loadUser() {
      return this.$http.get('v1/admin/me')
        .then(response => response.data.data)
        .catch(() => null)
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
</style>
